import { Route, Switch } from 'react-router-dom';

import { PATHS } from '@src/packages/workJourney/constants';

import { WorkJourneyCoverAbsenceDrawer } from './components/CoverPositionDrawers/WorkJourneyCoverAbsenceDrawer';
import { WorkJourneyCoverAbsenceReplaceDrawer } from './components/CoverPositionDrawers/WorkJourneyCoverAbsenceReplaceDrawer';
import { WorkJourneyCoverShortageDrawer } from './components/CoverPositionDrawers/WorkJourneyCoverShortageDrawer';
import { WorkJourneyResolveRejectedChangeDrawer } from './components/CoverPositionDrawers/WorkJourneyResolveRejectedChangeDrawer';

interface WorkJourneyManagementRoutesProps {
  url: string;
}

export const WorkJourneyManagementRoutes = ({ url }: WorkJourneyManagementRoutesProps) => (
  <Switch>
    <Route
      path={`${url}/${PATHS.WORK_JOURNEY_COVER_ABSENCE_REPLACE}`}
      component={WorkJourneyCoverAbsenceReplaceDrawer}
    />
    <Route
      path={`${url}/${PATHS.WORK_JOURNEY_COVER_ABSENCE}`}
      component={WorkJourneyCoverAbsenceDrawer}
    />
    <Route
      path={`${url}/${PATHS.WORK_JOURNEY_COVER_SHORTAGE}`}
      component={WorkJourneyCoverShortageDrawer}
    />
    <Route
      path={`${url}/${PATHS.WORK_JOURNEY_RESOLVE_REJECTED_CHANGE}`}
      component={WorkJourneyResolveRejectedChangeDrawer}
    />
  </Switch>
);
